import { Component, OnInit, AfterViewInit, Input } from '@angular/core';

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
})
export class TabsComponent implements OnInit, AfterViewInit {
  @Input() data: any;
  @Input() type: any;

  constructor() {}

  ngOnInit(): void {}

  /**
   * -------------------------------------------------------
   * @summary ngAfterViewInit
   * @description  Inicializa funciones despues de cargar toda la pagina
   * -------------------------------------------------------
   */
  ngAfterViewInit(): void {
    setTimeout(() => {
      let ele = document.querySelector('.panel-tab');
      ele.classList.add('active');
    }, 500);
  }

  /**
   * -------------------------------------------------------
   * @summary changeActiveTab
   * @description  Cambiar tabs activo
   * @param {bollean} value valor del estado para abrir el menu
   * -------------------------------------------------------
   */
  changeActiveTab(data: any, index: number, event: any) {
    const element =(event.composedPath && event.composedPath())[3].childNodes[2].childNodes[0].childNodes[index - 1] .childNodes[0].childNodes[0]
    const panel = element.childNodes[0];
    data.forEach((item) => {
      if (item.id === index) {
        item.active = true;
        panel.classList.remove('active');
        setTimeout(() => {
          panel.classList.add('active');
        }, 200);
      } else {
        item.active = false;
        panel.classList.remove('active');
      }
    });
  }
}
